<template>
    <div>
      <b-row v-if="pdv == 2">
        <b-col>
          {{accionTienda()}}
        </b-col>
      </b-row>
        <b-row v-else>
            <b-col>
              <b-row>
                <b-col>
                  <div class="text-center">
                    <strong>TOTALES</strong>
                    <!-- <b-btn v-b-modal.modalemitirguia><i class="fa fa-eye"></i></b-btn>
                        <b-modal id="modalemitirguia" title="Guia de remision" size="lg">
                            <p class="my-4">{{ invoice }}</p>
                    </b-modal> -->
                  </div>
                </b-col>
              </b-row>
              <!-- <b-row>
                <b-col cols="6" sm="6"	md="6"	lg="6"	xl="6">
                  <strong>Otros Cargos:</strong>
                </b-col>
                <b-col cols="2" sm="2"	md="2"	lg="2"	xl="2">
                  {{ monedabuffer.simbolo }}
                </b-col>
                <b-col cols="4" sm="4"	md="4"	lg="4"	xl="4">
                  <b-row>
                    <b-col cols="12" sm="12"	md="12"	lg="12"	xl="12" class="checkdescuentoglobal"><b-input v-model="otrosCargos" disabled></b-input></b-col>
                  </b-row>
                </b-col>
              </b-row> -->
              <hr>
              <b-row>
                <b-col cols="6" sm="6"	md="6"	lg="6"	xl="6">
                  <div><strong>IGV:</strong></div>
                  <div><strong>Venta Gravada:</strong></div>
                  <div><strong>Venta Exonerada:</strong></div>
                  <div><strong>Venta Inafecta:</strong></div>
                  <div v-if="identificadorPro ==0"><strong>Venta Gratuita:</strong></div>
                  <div v-if="identificadorPro ==0"><strong>Venta Exportación:</strong></div>
                  <div><strong>Descuentos:</strong></div>
                  <div v-if="identificadorPro ==0"><strong>Otros Cargos:</strong></div>
                  <div><strong>Venta:</strong></div>
                  <b-row>
                    <b-col cols="12">
                      <template v-if="tipoOperacion == '1001'">
                        <hr>
                        <select class="form-control input-placedark input-dark" v-model="detraccion">
                          <option v-for="detraccion in listaDeDetracciones" :value="detraccion" :key="detraccion.codigo">{{ detraccion.descripcion }}</option>
                        </select>
                        <br>
                      </template>
                    </b-col>
                  </b-row>
                </b-col>
                <b-col cols="2" sm="2"	md="2"	lg="2"	xl="2">
                  <div v-if="identificadorPro ==0">
                    {{ monedabuffer.simbolo }}
                  </div>
                  <div v-if="identificadorPro ==0">
                    {{ monedabuffer.simbolo }}
                  </div>
                  <div v-if="identificadorPro ==0">
                    {{ monedabuffer.simbolo }}
                  </div>
                  <div>
                    {{ monedabuffer.simbolo }}
                  </div>
                  <div>
                    {{ monedabuffer.simbolo }}
                  </div>
                  <div>
                    {{ monedabuffer.simbolo }}
                  </div>
                  <div>
                    {{ monedabuffer.simbolo }}
                  </div>
                  <div>
                    {{ monedabuffer.simbolo }}
                  </div>
                  <div>
                    {{ monedabuffer.simbolo }}
                  </div>
                </b-col>
                <b-col cols="4" sm="4"	md="4"	lg="4"	xl="4">
                  <div class="alineacionTotales">
                    {{ accumulateIgv() }}
                  </div>
                  <div v-if="descuentoGlobalMonto != '' || descuentoGlobalPorcentaje != ''" class="alineacionTotales">
                    {{ totalVentaGravada }}
                  </div>
                  <div v-else class="alineacionTotales">
                    {{ accumulateRecordedSale() }}
                  </div>
                  <div class="alineacionTotales">
                    {{ accumulateExoneratedSale() }}
                  </div>
                  <div class="alineacionTotales">
                    {{ accumulateUnaffectedSale() }}
                  </div>
                  <div v-if="identificadorPro ==0" class="alineacionTotales">
                    {{ accumulateFreeSale() }}
                  </div>
                  <div v-if="identificadorPro ==0" class="alineacionTotales">
                    {{ accumulateExportSale() }}
                  </div>
                  <div class="alineacionTotales">
                    {{ accumulateDescuento() }}
                  </div>
                  <div v-if="identificadorPro ==0" class="alineacionTotales">
                    {{ accumulateOtrosCargos() }}
                  </div>
                  <div class="alineacionTotales">
                    <strong>{{ accumulateTotalSale() }}</strong>
                  </div>
                  <template v-if="tipoOperacion == '1001'">
                    <hr>
                    <b-row>
                      <b-col cols="4">{{ detraccion.porcentajeDetraccion }}</b-col>
                    </b-row>
                    <b-row>
                      <b-col cols="8">{{ monedabuffer.simbolo }} {{ montoDetraccionCalc() }}</b-col>
                    </b-row>
                  </template>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12">
                  <template v-if="tipoOperacion == '1001'">
                    <b-alert show variant="info">
                      <b-row>
                        <b-col cols="6">Cuenta de Detracciones: </b-col>
                        <b-col cols="6">
                          <template v-if="cuentaDetracionAdmin != ''">
                            <b-col cols="12">
                              <template v-if="cuentaDetracionAdmin != ''">
                                {{ cuentaDetracionAdmin }}
                              </template>
                              <template v-else>
                                No existe cuenta de detracción, registrelo en Administrador/Perfil
                              </template>
                            </b-col>
                          </template>
                          <template v-else>
                            Cargando <i class="fa fa-spin fa-spinner"></i>
                          </template>
                        </b-col>
                      </b-row>
                    </b-alert>
                  </template>
                </b-col>
              </b-row>
              <br>
            </b-col>
        </b-row>
    </div>
</template>

<script>
    export default {
        name: 'Totales',
        components: {},
        props: ['pdv','items', 'monedabuffer', 'cargos','identificadorPro'],
        data: () => {
            return {
                moneda: {
                    id: '1',
                    codigo: 'PEN',
                    descripcion: 'SOLES',
                    simbolo: 'S/.'
                },
                otrosCargos: 0,
                tipoOperacion: '0101',
                descuentoGlobalMonto: '',
                descuentoGlobalPorcentaje: '',
                descuentoItemMonto: '',
                descuentoItemPorcentaje: '',
                checkedDsctoGlobal: true,
                detraccionCarga: false,
                descuentoGlobalMonto: 0,
                factorNumericoDescuento: 0,
                montoDescuento: 0,
                montoBaseDescuento: 0,
                montoTotalImpuestos: 0,
                sumatoriaIgv: 0,
                sumatoriaIgvGratuitas: 0,
                sumatoriaOtrosCargos: 0,
                totalVentaGravada: 0,
                totalVentaExonerada: 0,
                totalVentaInafecta: 0,
                totalVentaGratuita: 0,
                totalVentaExportacion: 0,
                importeTotal: 0,
                baseCargo: 0
            }
        },
        mounted(){
         
        },
        watch: {
            tipoOperacion: function () {
                // Operaciones sujetas a detraccion
                if(this.tipoOperacion == '1001' || this.tipoOperacion == '1002'){
                    this.showAccountDetraction()
                    // this.detraccionCarga = false
                }else if(this.tipoOperacion == '0200'){
                    // this.receptor.tipo = '0',
                    // this.disabledGratuita = true
                    // this.detraccionCarga = false
                }else if(this.tipoOperacion == '1004'){
                    this.showAccountDetraction()
                    // this.detraccionCarga = true
                    this.items = []
                }else{
                    // this.receptor.tipo = '6',
                    // this.disabledGratuita = false
                    // this.detraccionCarga = false
                }
            },
            checkedDsctoGlobal: function () {
                this.descuentoGlobalMonto = ''
                this.descuentoGlobalPorcentaje = ''
            },
            descuentoGlobalMonto: function () {
                let ventaGravadaActual = this.totalVentaGravada
                if(this.totalVentaGravada > 0){
                    if(this.descuentoGlobalMonto != ''){
                    this.factorNumericoDescuento = (this.descuentoGlobalMonto * 100) / ventaGravadaActual
                    this.montoDescuento = this.descuentoGlobalMonto
                    this.montoBaseDescuento = ventaGravadaActual
                    this.totalVentaGravada = ventaGravadaActual - this.montoDescuento
                    }
                }
            },
            descuentoGlobalPorcentaje: function () {
                let ventaGravadaActual = this.totalVentaGravada
                if(this.totalVentaGravada > 0){
                    if(this.descuentoGlobalPorcentaje != ''){
                    this.factorNumericoDescuento = this.descuentoGlobalPorcentaje / 100
                    this.montoDescuento = (this.descuentoGlobalPorcentaje / 100) * ventaGravadaActual
                    this.montoBaseDescuento = ventaGravadaActual - this.montoDescuento
                    this.totalVentaGravada = ventaGravadaActual - this.montoDescuento
                    }
                }
            },
        },
        methods: {
            accumulateIgv: function () {
                let val = 0.00
                let valGratuita = 0.00
                this.items.forEach(function(element) {
                    if(element.codigoTributo == '9996' && element.tipoPrecioVentaUnitario == '02'){
                        valGratuita += parseFloat(element.montoAfectacionIgv);
                    }else{
                        val += parseFloat(element.montoAfectacionIgv);
                    }
                });
                this.montoTotalImpuestos = val,
                this.sumatoriaIgv = val,
                this.sumatoriaIgvGratuitas = valGratuita
                return this.sumatoriaIgv.toFixed(2)
            },
            accumulateTaxes: function () {
                var val = 0.00
                this.items.forEach(function(element) {
                    val += parseFloat(element.montoAfectacionIgv);
                });
                this.sumatoriaIgv = val.toFixed(2)
            },
            accumulateRecordedSale: function () {
                let val = 0.00;
                let valGrabadaAnticipos = 0.00;
                this.items.forEach(function(element) {
                    if(element.tipoAfectacionIgv == '10'){
                    val += parseFloat(element.valorVenta);
                    }
                });
                this.totalVentaGravada = val
                return this.totalVentaGravada.toFixed(2)
            },
            accumulateExoneratedSale: function () {
                let val = 0.00;
                let valExoneradoAnticipos = 0.00;
                this.items.forEach(function(element) {
                    if(element.tipoAfectacionIgv == '20'){
                    val += parseFloat(element.valorVenta);
                    }
                });
                this.totalVentaExonerada = val
                return this.totalVentaExonerada.toFixed(2)
            },
            accumulateUnaffectedSale: function () {
                var val = 0.00;
                let valInafectaAnticipos = 0.00;
                this.items.forEach(function(element) {
                    if(element.tipoAfectacionIgv == '30'){
                    val += parseFloat(element.valorVenta);
                    }
                });
                this.totalVentaInafecta = val
                return this.totalVentaInafecta.toFixed(2)
            },
            accumulateFreeSale: function () {
                var val = 0.00
                this.items.forEach(function(element) {
                    if(element.tipoAfectacionIgv == '11' ||
                    element.tipoAfectacionIgv == '12' ||
                    element.tipoAfectacionIgv == '13' ||
                    element.tipoAfectacionIgv == '14' ||
                    element.tipoAfectacionIgv == '15' ||
                    element.tipoAfectacionIgv == '16' ||
                    element.tipoAfectacionIgv == '31' ||
                    element.tipoAfectacionIgv == '32' ||
                    element.tipoAfectacionIgv == '33' ||
                    element.tipoAfectacionIgv == '34' ||
                    element.tipoAfectacionIgv == '35' ||
                    element.tipoAfectacionIgv == '36' ||
                    element.tipoAfectacionIgv == '21'
                ){
                    val += parseFloat(element.valorVenta);
                }
                });
                this.totalVentaGratuita = val
                return val.toFixed(2)
            },
            accumulateExportSale: function () {
                var val = 0.00;
                this.items.forEach(function(element) {
                if(element.tipoAfectacionIgv == '40'){
                    val += parseFloat(element.valorVenta);
                }
                });
                this.totalVentaExportacion = val
                return val.toFixed(2)
            },
            accumulateTotalSale: function () {
                if(this.totalVentaGravada != 0 || this.totalVentaInafecta != 0 || this.totalVentaExonerada != 0 || this.totalVentaExportacion != 0){
                  this.importeTotal = this.montoTotalImpuestos + this.totalVentaGravada + this.totalVentaInafecta + this.totalVentaExonerada + this.totalVentaExportacion + this.sumatoriaOtrosCargos
                  this.baseCargo = this.importeTotal - this.sumatoriaOtrosCargos
                }else{
                  this.importeTotal = 0
                  this.baseCargo = 0
                }
                this.loaddatatotal()
                return this.importeTotal.toFixed(2)
            },
            accumulateDescuento: function () {
                var val = 0.00;
                this.items.forEach(function(element) {
                  if(element.descuento){
                    val += parseFloat(element.descuento);
                  }else{
                    val += 0.00
                  }
                
                });
                this.totalDescuentosAcumulados = val
                return val.toFixed(2)
            },
            accumulateOtrosCargos: function () {
                let val = 0.00
                if(typeof(this.cargos) != "undefined"){
                  this.cargos.forEach(function(element) {
                    val += parseFloat(element.montoCargo);
                  });
                  this.sumatoriaOtrosCargos = val
                }
                return val.toFixed(2)
            },
            loaddatatotal: function () {
              let datatotal = {}
              datatotal.sumatoriaIgv = this.sumatoriaIgv,
              datatotal.sumatoriaOtrosCargos = this.sumatoriaOtrosCargos,
              datatotal.baseCargo = this.baseCargo,
              datatotal.totalVentaGravada = this.totalVentaGravada,
              datatotal.totalVentaExonerada = this.totalVentaExonerada,
              datatotal.totalVentaInafecta = this.totalVentaInafecta,
              datatotal.totalVentaGratuita = this.totalVentaGratuita,
              datatotal.totalVentaExportacion = this.totalVentaExportacion,
              datatotal.montoTotalImpuestos = this.montoTotalImpuestos,
              datatotal.importeTotal = this.importeTotal
              this.cargarTotales(datatotal)
            },
            cargarTotales: function (data) {
              this.$emit("loadtotal", data)
            },
            accionTienda(){
              this.accumulateIgv();
              this.accumulateRecordedSale();
              this.accumulateExoneratedSale();
              this.accumulateUnaffectedSale();
              this.accumulateFreeSale();
              this.accumulateExportSale();
              this.accumulateDescuento();
              this.accumulateOtrosCargos();
              this.accumulateTotalSale();

            }
        }
        
    }
</script>

<style>

</style>